export default __webpack_public_path__ + "static/media/news95.ebcbeaf8.jpg";